let glamCardContainer = document.getElementById(
  "Glam-cards"
);

console.log("glam rendering with these elements:", glamCardContainer)

renderGlamCard(
  41005127008349,
  "gift-card-one",
  "https://ucarecdn.com/5b88ad30-53ec-49c5-8ad1-cbd7fd482110/"
);
renderGlamCard(
  41005126975581,
  "gift-card-two",
  "https://ucarecdn.com/910950c3-adfd-4421-96e7-50643b52a2db/"
);

// deprecated
function renderGlamInfo() {
  let a = document.createElement("a");
  a.href = "https://www.cereschill.com/products/chiller-glam-card";
  a.className = "text-link text-link--accent glam-product-link";
  a.innerText = "Visit the product page to learn more. $4.25 per card.";
  glamCardParent.prepend(a);
  let p = document.createElement("p");
  p.className = "cart-note__label small--text-center glam-title";
  p.innerText = "Add a personalized gift card! Check out our beautiful Chiller Glam Cards below (waterproof stickers included)!";
  glamCardParent.prepend(p);
}

function renderGlamCard(variantId, alt, src) {
  let outerDiv = glamCardContainer.appendChild(document.createElement("div"));
  outerDiv.classList.add("flip-card");
  let innerDiv = outerDiv.appendChild(document.createElement("div"));
  innerDiv.classList.add("flip-card-inner");
  let frontDiv = innerDiv.appendChild(document.createElement("div"));
  frontDiv.classList.add("flip-card-front");
  let frontImg = frontDiv.appendChild(document.createElement("img"));
  frontImg.src = src;
  frontImg.alt = alt;
  frontImg.classList.add("glam-card-image");
  let backForm = innerDiv.appendChild(document.createElement("form"));
  backForm.classList.add("flip-card-back");
  backForm.variantId = variantId;
  backForm.id = "product_form_" + variantId;
  backForm.addEventListener("submit", onSubmitForm);
  let backTitle = backForm.appendChild(document.createElement("label"));
  backTitle.innerText = "Enter a message:";
  backTitle.htmlFor = `back-text-area-${variantId}`;
  let backTextArea = backForm.appendChild(document.createElement("textarea"));
  backTextArea.classList.add("textarea-no-resize");
  backTextArea.id = `back-text-area-${variantId}`;
  backTextArea.addEventListener("focusin", onFocusIn);
  backTextArea.addEventListener("focusout", onFocusOut);
  let backInvisibleDiv = backForm.appendChild(document.createElement("div"));
  backInvisibleDiv.classList.add("flip-card-invisible");
  let backSubmitButton = backInvisibleDiv.appendChild(document.createElement("input"));
  backSubmitButton.className = "button btn glam-submit-button";
  backSubmitButton.setAttribute("type", "submit");
  let textSpan = backSubmitButton.appendChild(document.createElement("span"));
  textSpan.textContent = "ADD TO CART";
}

function onFocusIn(event) {
  let backTextArea = event.target;
  let flipCard = backTextArea.parentElement.parentElement.parentElement;
  flipCard.classList.add("glam-focused");
}

function onFocusOut(event) {
  let backTextArea = event.target;
  let flipCard = backTextArea.parentElement.parentElement.parentElement;
  flipCard.classList.remove("glam-focused");
}

async function onSubmitForm(event) {
  event.preventDefault();
  const form = event.target;
  
  await UpdateNotes(form);
  await AddGlam(form);
  setTimeout(() => {
    window.location.href = '/cart';
  }, 500);
}

async function AddGlam(form) {
  const variantIdAdded = form.variantId;
  let addedItems = {
    items: [
      {
        id: variantIdAdded,
        quantity: 1,
      }
    ],
  }

  let params = {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(addedItems)
  };

  const res = await fetch(window.Shopify.routes.root + 'cart/add.js', params);
  if(res.status != 200) {
    return;
  };
  const data = await res.json();
}

async function UpdateNotes(form) {
  const currentNotes = document.getElementById("Cart-note").value;
  const glamMessage = form.elements[0].value;
  if(glamMessage == '') {
    return;
  }
  let update = {
    note: currentNotes + `\nMessage for Glam Card: ${glamMessage}`
  }
  let params = {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(update)
  };
  const res = await fetch(window.Shopify.routes.root + 'cart/update.js', params);
  if(res.status != 200) {
    return;
  };
}